import { Component, Host, h, Element, Listen, State } from '@stencil/core';
import { addClass } from '../../utils/helpers/helpers';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

@Component({
  tag: 'lgr-carousel',
  styleUrl: 'carousel.scss',
  shadow: false,
})
export class Carousel {
  @Element() el!: HTMLLgrCarouselElement;

  @State() isMobile: boolean = true;

  @Listen('resize', { target: 'window' })
  windowResize() {
    if (window.innerWidth < 768) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  }

  private swiper: Swiper | any;

  private initializeSwiper = () => {
    this.swiper = new Swiper('.swiper-carousel', {
      modules: [Navigation],
      slidesPerView: 1.25,
      spaceBetween: 16,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }

  componentWillLoad() {
    this.windowResize()
  }

  componentDidRender() {
    this.isMobile ? this.initializeSwiper() : this.swiper && this.swiper.destroy();
  }

  render() {
    return (
      <Host class={`${addClass([this.isMobile ? 'swiper-carousel' : null])}`}>
        <div class={`${addClass([this.isMobile ? 'swiper-wrapper' : 'lgr-carousel-grid'])}`}>
          <slot />
        </div>
        <div class={{
          "none": !this.isMobile
        }}>
          <div class="swiper-button-next"><lgr-icon>chevron_right</lgr-icon></div>
          <div class="swiper-button-prev"><lgr-icon>chevron_left</lgr-icon></div>
        </div>
      </Host>
    );
  }
}
